function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import tasks from '@/js/tasks';
import utils from '@/js/utils';
import { ROLES_LIST, PERIODS, PATTERNS_VALIDATION, DATAPLEX_STATES } from '@/js/constants';
import DialogsComponent from '@/components/DialogsComponent.vue';
import dataplex_service from '@/apps/data-platform/services/data_quality/dataplex_service';
import assignments_service from '@/apps/data-platform/services/tables_views/assignments_service';
import UserSecurityService from '@/apps/data-platform/services/security/user_security_service';
import domainService from '@/apps/data-platform/services/master_data/domain_service';
import TextFieldCalendarComponent from '@/components/TextFieldCalendarComponent';
import TextFieldRecipientsComponent from '@/components/TextFieldRecipientsComponent';
import ProfilingExecutionDetailComponent from '@/apps/data-platform/modules/data_quality_dataplex/components/ProfilingExecutionDetailComponent';
import channel_service from '@/apps/chatbots/services/channels_services';
import OrganizacionComponent from '@/components/OrganizacionComponent.vue';
export default {
  name: 'CreateChannelComponent',
  props: {
    mode_: {
      type: String,
      required: true,
      default: 'create'
    }
  },
  components: {
    TextFieldCalendarComponent: TextFieldCalendarComponent,
    TextFieldRecipientsComponent: TextFieldRecipientsComponent,
    ProfilingExecutionDetailComponent: ProfilingExecutionDetailComponent,
    OrganizacionComponent: OrganizacionComponent
  },
  data: function data() {
    return {
      DATAPLEX_STATES: DATAPLEX_STATES,
      PREFIX: 'INCA_dp_',
      PREFIX_ID: 'inca-dp-',
      tab: 0,
      edit: false,
      view: false,
      filters: {},
      show_detail: false,
      filter_enabled: true,
      collapse_filter: false,
      emailPattern: PATTERNS_VALIDATION.EMAIL_GENERAL,
      execution_selected: {},
      errors_recipients: [],
      last_modification_table: null,
      channel: {
        identity_connection: '',
        type: '',
        url: '',
        name: '',
        description: '',
        state: '',
        project: {},
        metadata: {}
      },
      list_orgs: [],
      types: [{
        value: 'WHATSAPP',
        text: 'Whatsapp'
      }, {
        value: 'PLAYGROUND',
        text: 'Playground'
      }, {
        value: 'SUPPLIER',
        text: 'Proveedor'
      }, {
        value: 'AZURE_BOT',
        text: 'Azure Bot'
      }],
      states: ['CONNECT', 'DISCONNECT'],
      rules: {
        url: [function (v) {
          return !!v || 'Este campo es obligatorio';
        }
        //(v) => /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/\S*)?$/.test(v) || 'URL no válida'
        ],
        name: [function (v) {
          return !!v || 'El campo es requerido.';
        }, function (v) {
          return v && v.length <= 100 || 'Menor o igual a 100 caracteres.';
        }],
        description: [function (v) {
          return v === '' || v === undefined || v == null || v && v.length <= 1024 || 'Menor o igual a 1024 caracteres.';
        }]
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['projects', 'catalogs', 'orgs', 'isDomainItc', 'has_dataplex_active'])), {}, {
    getClassTable: function getClassTable() {
      if (this.filter_enabled) {
        return 'col-md-9 col-sm-12';
      } else {
        return 'col-sm-12';
      }
    }
  }),
  created: function created() {
    if (!this.has_dataplex_active) {
      this.$router.push({
        name: 'HomePage'
      });
      return;
    }
    this.id = this.$router.currentRoute.params.id;
    this.mode = this.mode_;
    if (this.mode === 'edit') {
      this.edit = true;
    }
    if (this.mode === 'view') {
      this.view = true;
    }
    if (this.id) {
      this.getChannel();
    }
    this.getListOrgsDetailed();
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    getListOrgsDetailed: function getListOrgsDetailed() {
      var _this = this;
      domainService.getOrganizationsDetail().then(function (response) {
        if (response.success) {
          _this.list_orgs = response.data;
        }
      });
    },
    formatDate: function formatDate(data) {
      if (data) {
        return data ? data.substring(0, 19).replace('T', ' ') : '';
      }
      return '';
    },
    getChannel: function getChannel() {
      var _this2 = this;
      channel_service.get(this.id).then(function (response) {
        _this2.channel = response.data;
      });
    },
    onValidateForm: function onValidateForm() {
      return true;
    },
    onSaveChannel: function onSaveChannel() {
      var _this3 = this;
      if (!this.$refs.form_channel.validate()) {
        return;
      }
      if (!this.onValidateForm()) {
        return;
      }
      channel_service.create(this.channel).then(function (response) {
        if (response.success) {
          tasks.toast.success('El registro se guardó correctamente.');
          _this3.$emit('onSave', response.data.id);
        } else {
          if (response.message) {
            tasks.toast.error(response.message);
          } else {
            tasks.toast.error('No se pudo guardar el registro.');
          }
        }
      });
    },
    onUpdateChannel: function onUpdateChannel() {
      if (!this.$refs.form_channel.validate()) {
        return;
      }
      if (!this.onValidateForm()) {
        return;
      }
      channel_service.update(this.id, this.channel).then(function (response) {
        if (response.success) {
          tasks.toast.success('El registro se guardó correctamente.');
        } else {
          if (response.message) {
            tasks.toast.error(response.message);
          } else {
            tasks.toast.error('No se pudo guardar el registro.');
          }
        }
      });
    },
    onCancelar: function onCancelar() {
      this.$router.push({
        name: 'ChannelManagement'
      });
    },
    handleSave: function handleSave() {
      if (this.edit) {
        this.onUpdateChannel();
      } else {
        this.onSaveChannel();
      }
    }
  }
};